import { useTranslation } from '@sib/i18n';
import { cn } from '@sib/ui';
import { X } from '@sib/ui/icons';

interface TaskTagFieldValueProps {
  selectedTagsCount: number;
  onClearAll?: () => void;
}

export const TaskTagFieldValue = ({
  selectedTagsCount,
  onClearAll,
}: TaskTagFieldValueProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={cn('flex items-center text-sm font-medium', {
        'text-primary/50': selectedTagsCount === 0,
      })}
    >
      {selectedTagsCount > 0 ? (
        <>
          {t('components.taskForm.fields.tag.selectedCount', {
            count: selectedTagsCount,
          })}
          {onClearAll && (
            <button
              type="button"
              className="hover:bg-secondary-foreground/20 ml-1 rounded-full p-1 transition-all"
              onClick={e => {
                e.stopPropagation();
                onClearAll();
              }}
            >
              <X className="size-3 cursor-pointer" />
            </button>
          )}
        </>
      ) : (
        t('components.taskForm.fields.tag.placeholder')
      )}
    </span>
  );
};
